/**
 * Ferry Search Config'leri
 * Merkezi export dosyası
 */

export {
  FERRY_PASSENGER_TYPES,
  createFerryPassengerConfig,
  createDynamicFerryPassengerConfig,
  defaultFerryPassengerConfig,
  ferryPassengerDisplayFormatter,
} from "./passengerConfig";

export { ferryPassengerGeneralValidations } from "./generalValidations";

// Gelecekte eklenecek diğer search config'leri buradan export edilebilir
// export * from "./locationConfig";
// export * from "./dateConfig";
// export * from "./filterConfig";
